import { SimpleObjectInterface } from '@thewhite/react-global-module/lib/interfaces';
import { TypeService } from '@thewhite/react-global-module/lib/services';

export enum BaseProgressStatusEnum {
    APPROVED   = 'APPROVED',
    CANCELED   = 'CANCELED',
    DECLINED   = 'DECLINED',
    DONE       = 'DONE',
    MODERATION = 'MODERATION',
    REVOKED    = 'REVOKED',
}

export interface BaseProgressStatusParams {
    [value: string]: SimpleObjectInterface;

    APPROVED: SimpleObjectInterface;
    CANCELED: SimpleObjectInterface;
    DECLINED: SimpleObjectInterface;
    DONE: SimpleObjectInterface;
    MODERATION: SimpleObjectInterface;
    REVOKED: SimpleObjectInterface;
}

const BASE_PROGRESS_STATUS: BaseProgressStatusParams = {
    APPROVED: {
        name: 'Подтверждено',
        value: 'APPROVED',
    },
    CANCELED: {
        name: 'Отменено',
        value: 'CANCELED',
    },
    DECLINED: {
        name: 'Отклонено',
        value: 'DECLINED',
    },
    DONE: {
        name: 'Проведено',
        value: 'DONE',
    },
    MODERATION: {
        name: 'Забронировано',
        value: 'MODERATION',
    },
    REVOKED: {
        name: 'Удалено',
        value: 'REVOKED',
    },
};

export default BASE_PROGRESS_STATUS;

export const BaseProgressStatusEnumType = TypeService.createEnum<BaseProgressStatusEnum>(BaseProgressStatusEnum, 'BaseProgressStatusEnum');
